import React, { useEffect, useState } from "react";
import AxiosController from "../../../authentication/AxiosController";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BlueRow from "./BlueRow";

const FulfillmentStats = () => {
  const { slug, lang } = useParams();
  const token = localStorage.getItem("token");
  const [fulfillmentStats, setFulfillmentStats] = useState({});
  const [_] = useTranslation("global");

  const [altName, handleAltName] = useState();
  const fulfillment_stats = () => {
    AxiosController.get(`api/${slug}/${lang}/get-fulfillments-stats-wallet/`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        setFulfillmentStats(res.data);
        handleAltName(res.data.alt_name);
      })
      .catch((e) => {});
  };
  useEffect(() => {
    fulfillment_stats();
  }, []);
  return (
    <div className="mt-2">
      <BlueRow
        slug={altName}
        values={[
          fulfillmentStats.total_expected
            ? fulfillmentStats.total_expected.toLocaleString()
            : 0,
          fulfillmentStats.total_confirmed
            ? fulfillmentStats.total_confirmed.toLocaleString()
            : 0,
          fulfillmentStats.total_balances
            ? fulfillmentStats.total_balances.toLocaleString()
            : 0,
          fulfillmentStats.total_pending
            ? fulfillmentStats.total_pending.toLocaleString()
            : 0,
        ]}
        image={fulfillmentStats.image}
        titles={[
          _("panel.expectedearnings"),
          _("panel.confirmedearnings"),
          _("panel.withdrawableearnings"),
          _("panel.pendingEarnings"),
        ]}
      />
    </div>
  );
};

export default FulfillmentStats;
